// extracted by mini-css-extract-plugin
module.exports = {"SideMenuItem":"SideNavMenuItems_SideMenuItem__3fniW"};